import React from 'react';
import styled from 'styled-components';
import { LogoActiveProps } from './types';

const HeartSvg = styled.svg`
  path {
    transition: fill 0.3s ease-in-out;
  }

  &.mod-active {
    background: var(--theme-color-primary);

    path {
      fill: white;
    }
  }
`;

function Heart({ width, height, color, active }: LogoActiveProps) {
  return (
    <HeartSvg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={active ? 'mod-active' : ''}
      viewBox="0 0 25 25"
      fill="none"
    >
      <path
        d="M17.1872 2.94238C15.3747 2.94238 13.6351 3.78613 12.4997 5.11947C11.3643 3.78613 9.62467 2.94238 7.81217 2.94238C4.60384 2.94238 2.08301 5.46322 2.08301 8.67155C2.08301 12.609 5.62467 15.8174 10.9893 20.6924L12.4997 22.057L14.0101 20.682C19.3747 15.8174 22.9163 12.609 22.9163 8.67155C22.9163 5.46322 20.3955 2.94238 17.1872 2.94238ZM12.6038 19.1403L12.4997 19.2445L12.3955 19.1403C7.43717 14.6507 4.16634 11.682 4.16634 8.67155C4.16634 6.58822 5.72884 5.02572 7.81217 5.02572C9.41634 5.02572 10.9788 6.05697 11.5309 7.48405H13.4788C14.0205 6.05697 15.583 5.02572 17.1872 5.02572C19.2705 5.02572 20.833 6.58822 20.833 8.67155C20.833 11.682 17.5622 14.6507 12.6038 19.1403Z"
        fill={color}
      />
    </HeartSvg>
  );
}

export default Heart;
